import {AxiosError} from "axios";
import {useState} from "react";
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";
import {ApiConfig} from "../api/portal/ApiConfig";
import {AuthApi} from "../api/portal/generated";
import {RenderAlert} from "../common/RenderAlert";
import {logger} from "../utils/Logger";
import {StringUtils} from "../utils/StringUtils";
import {Utils} from "../utils/Utils";
import {XSRF} from "./Xsrf";

/*
 * REST api for accessing the back-end
 */
const authApi = new AuthApi(ApiConfig.config());

export const PortalForgotPassword = () =>
{
    /**
     * Email address
     */
    const [email, setEmail] = useState<string>();
    /**
     * true if a reset was sent
     */
    const [resetSent, setResetSent] = useState<boolean>(false);
    /**
     * The error message if some error occurred which is not a validation error
     */
    const [errorMessage, setErrorMessage] = useState<string>();
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    const startPasswordReset = () =>
    {
        if (email === undefined) {
            throw Error("email is undefined");
        }

        // a XSRF cookie is required
        XSRF.generateCookie();

        setErrorMessage(undefined);

        authApi.authControllerForgotPassword(email)
            .then(() =>
            {
                setResetSent(true);
            })
            .catch((err: Error | AxiosError) => {
                logger.error("Error starting password reset", err);
                setErrorMessage(Utils.getErrorMessage(err, t));
            })
    }

    return (
        <Form className="w-100 p-4 shadow-sm rounded bg-white">
            <div className="mb-4 text-center">
                <h2>{t("portal.forgot-password.title")}</h2>
            </div>

            {/* show an alert if a validation error occurred */}
            <RenderAlert message={errorMessage}/>

            {resetSent && <RenderAlert message={t('portal.forgot-password.reset-sent')} variant="success"/>}

            <FloatingLabel label={t('portal.forgot-password.email-label')} className="text-secondary mb-3">
                <Form.Control type="email" value={email} placeholder="Email"
                              onChange={e => setEmail(e.target.value)}/>
            </FloatingLabel>

            <Button variant="success" className="w-100 mt-4" disabled={StringUtils.isEmpty(email) || resetSent}
                    onClick={startPasswordReset}>
                {t('portal.forgot-password.reset-button')}
            </Button>
        </Form>
    );
}
